export default __webpack_public_path__ + "static/media/houzz2021.6afcba16.png";